import type {FilterRule} from "crqlar-react-common/dist/models/audience/filter.model";
import type {DateRange} from "crqlar-react-common/dist/models/common/dateRange";

export const filterTextValues = (rules: FilterRule[], field: string) => {
    const values = rules
        .filter(rule => rule.field === field)
        .flatMap(rule => rule.textValues ?? [])
        .filter((value): value is string => !!value);

    return values.length ? Array.from(new Set(values)) : undefined;
};

export const filterNumberValues = (rules: FilterRule[], field: string) => {
    const values = filterTextValues(rules, field)
        ?.map(Number)
        .filter(Number.isFinite);

    return values?.length ? Array.from(new Set(values)) : undefined;
};

export const filterEnumValues = <TValue extends string>(
    rules: FilterRule[],
    field: string,
    allowedValues: readonly TValue[]
) => filterTextValues(rules, field)?.filter(
    (value): value is TValue => allowedValues.includes(value as TValue)
);

export const filterDateRange = (rules: FilterRule[], field: string): DateRange | undefined => {
    const [start, end] = rules.find(rule => rule.field === field)?.timestampValues ?? [];
    return start && end ? {start: new Date(start), end: new Date(end)} : undefined;
};
